import React, { useState } from 'react';
import { Building2, Mail, Phone, Globe, AlertTriangle, Clock, FileCheck, Send, UploadCloud, ChevronLeft, ChevronDown, ChevronUp, CheckCircle, XCircle, History } from 'lucide-react';
export function SupplierDetails() {
  const [expandedCertId, setExpandedCertId] = useState<number | null>(null);
  const supplier = {
    id: 1,
    name: 'Global Ingredients Co.',
    type: 'Raw Materials',
    status: 'at-risk',
    address: '123 Supply Chain Ave, Industry Park, CA 94103',
    email: 'compliance@globalingredients.com',
    phone: '+1 (555) 123-4567',
    website: 'www.globalingredients.com',
    complianceScore: 85,
    lastUpdated: '2 days ago',
    certifications: [{
      id: 1,
      name: 'FDA Registration',
      status: 'valid',
      type: 'critical',
      expiryDate: '2024-12-31',
      lastUpdated: '2023-12-15',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2023-12-15',
        type: 'submission',
        status: 'approved',
        document: 'FDA_Registration_2024.pdf',
        notes: 'Annual registration renewal approved',
        reviewer: 'Sarah Johnson'
      }, {
        id: 2,
        date: '2023-12-10',
        type: 'submission',
        status: 'pending',
        document: 'FDA_Registration_2024.pdf',
        notes: 'Submitted for annual renewal',
        reviewer: null
      }, {
        id: 3,
        date: '2023-01-15',
        type: 'expiry_notice',
        status: 'notification',
        document: null,
        notes: 'Renewal reminder sent',
        reviewer: null
      }]
    }, {
      id: 2,
      name: 'Organic Certification',
      status: 'expiring-soon',
      type: 'critical',
      expiryDate: '2024-02-15',
      lastUpdated: '2023-06-20',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2023-06-20',
        type: 'submission',
        status: 'approved',
        document: 'Organic_Certification_2024.pdf',
        notes: 'Organic certification approved',
        reviewer: 'John Doe'
      }, {
        id: 2,
        date: '2023-06-15',
        type: 'submission',
        status: 'pending',
        document: 'Organic_Certification_2024.pdf',
        notes: 'Submitted for renewal',
        reviewer: null
      }, {
        id: 3,
        date: '2023-05-15',
        type: 'expiry_notice',
        status: 'notification',
        document: null,
        notes: 'Renewal reminder sent',
        reviewer: null
      }]
    }, {
      id: 3,
      name: 'GMP Certificate',
      status: 'expired',
      type: 'critical',
      expiryDate: '2024-01-01',
      lastUpdated: '2023-01-01',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2023-01-01',
        type: 'submission',
        status: 'approved',
        document: 'GMP_Certificate_2024.pdf',
        notes: 'GMP certificate approved',
        reviewer: 'Jane Smith'
      }, {
        id: 2,
        date: '2023-01-05',
        type: 'submission',
        status: 'pending',
        document: 'GMP_Certificate_2024.pdf',
        notes: 'Submitted for renewal',
        reviewer: null
      }, {
        id: 3,
        date: '2022-12-15',
        type: 'expiry_notice',
        status: 'notification',
        document: null,
        notes: 'Renewal reminder sent',
        reviewer: null
      }]
    }, {
      id: 4,
      name: 'Quality Management System',
      status: 'pending-review',
      type: 'non-critical',
      expiryDate: null,
      lastUpdated: '2024-01-10',
      documentUrl: '#',
      history: [{
        id: 1,
        date: '2024-01-10',
        type: 'submission',
        status: 'approved',
        document: 'QMS_2024.pdf',
        notes: 'QMS approved',
        reviewer: 'Emily Johnson'
      }, {
        id: 2,
        date: '2024-01-05',
        type: 'submission',
        status: 'pending',
        document: 'QMS_2024.pdf',
        notes: 'Submitted for renewal',
        reviewer: null
      }, {
        id: 3,
        date: '2023-12-15',
        type: 'expiry_notice',
        status: 'notification',
        document: null,
        notes: 'Renewal reminder sent',
        reviewer: null
      }]
    }],
    communications: [{
      id: 1,
      type: 'email',
      subject: 'Organic Certification Expiring Soon',
      status: 'sent',
      date: '2024-01-15',
      description: 'Reminder sent about certification expiring in 30 days'
    }, {
      id: 2,
      type: 'document',
      subject: 'GMP Certificate Upload',
      status: 'received',
      date: '2024-01-10',
      description: 'New GMP certificate uploaded for review'
    }, {
      id: 3,
      type: 'email',
      subject: 'GMP Certificate Expired',
      status: 'sent',
      date: '2024-01-02',
      description: 'Notification about expired certification'
    }]
  };
  const toggleCertification = (certId: number) => {
    setExpandedCertId(expandedCertId === certId ? null : certId);
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'approved':
        return <CheckCircle className="w-4 h-4 text-green-600" data-id="element-12" />;
      case 'rejected':
        return <XCircle className="w-4 h-4 text-red-600" data-id="element-13" />;
      case 'pending':
        return <Clock className="w-4 h-4 text-yellow-600" data-id="element-14" />;
      default:
        return <History className="w-4 h-4 text-gray-600" data-id="element-15" />;
    }
  };
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-16">
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-17">
        {/* Back Button */}
        <button className="flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-18">
          <ChevronLeft className="w-4 h-4 mr-1" data-id="element-19" />
          Back to Suppliers
        </button>
        {/* Supplier Header */}
        <div className="bg-white rounded-lg border p-6 mb-6" data-id="element-20">
          <div className="flex justify-between items-start" data-id="element-21">
            <div data-id="element-22">
              <h1 className="text-2xl font-semibold text-gray-900" data-id="element-23">
                {supplier.name}
              </h1>
              <p className="text-gray-600" data-id="element-24">{supplier.type}</p>
            </div>
            <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700" data-id="element-25">
              Edit Supplier
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-id="element-26">
            <div className="space-y-3" data-id="element-27">
              <div className="flex items-center text-gray-600" data-id="element-28">
                <Building2 className="w-4 h-4 mr-2" data-id="element-29" />
                {supplier.address}
              </div>
              <div className="flex items-center text-gray-600" data-id="element-30">
                <Mail className="w-4 h-4 mr-2" data-id="element-31" />
                {supplier.email}
              </div>
              <div className="flex items-center text-gray-600" data-id="element-32">
                <Phone className="w-4 h-4 mr-2" data-id="element-33" />
                {supplier.phone}
              </div>
              <div className="flex items-center text-gray-600" data-id="element-34">
                <Globe className="w-4 h-4 mr-2" data-id="element-35" />
                {supplier.website}
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4" data-id="element-36">
              <div className="flex items-center justify-between mb-2" data-id="element-37">
                <span className="text-gray-600" data-id="element-38">Compliance Score</span>
                <span className="text-lg font-semibold text-gray-900" data-id="element-39">
                  {supplier.complianceScore}%
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-40">
                <div className="bg-green-500 rounded-full h-2" style={{
                width: `${supplier.complianceScore}%`
              }} data-id="element-41"></div>
              </div>
            </div>
          </div>
        </div>
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-42">
          {/* Certifications */}
          <div className="lg:col-span-2" data-id="element-43">
            <div className="bg-white rounded-lg border" data-id="element-44">
              <div className="p-6 border-b border-gray-200" data-id="element-45">
                <div className="flex items-center justify-between" data-id="element-46">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-47">
                    Certification Requirements
                  </h2>
                  <button className="text-purple-600 hover:text-purple-700 font-medium" data-id="element-48">
                    Add Requirement
                  </button>
                </div>
              </div>
              <div className="p-6" data-id="element-49">
                <div className="space-y-4" data-id="element-50">
                  {supplier.certifications.map(cert => <div key={cert.id} className="border rounded-lg p-4 hover:bg-gray-50" data-id="element-51">
                      <button className="w-full" onClick={() => toggleCertification(cert.id)} data-id="element-52">
                        <div className="flex items-start justify-between" data-id="element-53">
                          <div data-id="element-54">
                            <div className="flex items-center space-x-2" data-id="element-55">
                              <h3 className="font-medium text-gray-900" data-id="element-56">
                                {cert.name}
                              </h3>
                              <span className={`px-2 py-1 text-xs font-medium rounded-full ${cert.type === 'critical' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-57">
                                {cert.type}
                              </span>
                            </div>
                            <div className="mt-1 text-sm text-gray-600" data-id="element-58">
                              {cert.status === 'valid' && <div className="flex items-center text-green-600" data-id="element-59">
                                  <FileCheck className="w-4 h-4 mr-1" data-id="element-60" />
                                  Valid until {cert.expiryDate}
                                </div>}
                              {cert.status === 'expiring-soon' && <div className="flex items-center text-yellow-600" data-id="element-61">
                                  <Clock className="w-4 h-4 mr-1" data-id="element-62" />
                                  Expires on {cert.expiryDate}
                                </div>}
                              {cert.status === 'expired' && <div className="flex items-center text-red-600" data-id="element-63">
                                  <AlertTriangle className="w-4 h-4 mr-1" data-id="element-64" />
                                  Expired on {cert.expiryDate}
                                </div>}
                              {cert.status === 'pending-review' && <div className="flex items-center text-blue-600" data-id="element-65">
                                  <Clock className="w-4 h-4 mr-1" data-id="element-66" />
                                  Pending Review
                                </div>}
                            </div>
                          </div>
                          <div className="flex space-x-2 items-center" data-id="element-67">
                            {cert.documentUrl && <button className="text-gray-600 hover:text-gray-900" onClick={e => e.stopPropagation()} data-id="element-68">
                                <FileCheck className="w-5 h-5" data-id="element-69" />
                              </button>}
                            <button className="text-purple-600 hover:text-purple-700" onClick={e => e.stopPropagation()} data-id="element-70">
                              <UploadCloud className="w-5 h-5" data-id="element-71" />
                            </button>
                            {expandedCertId === cert.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-72" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-73" />}
                          </div>
                        </div>
                      </button>
                      {/* Certification History */}
                      {expandedCertId === cert.id && <div className="mt-4 pt-4 border-t" data-id="element-74">
                          <h4 className="text-sm font-medium text-gray-900 mb-3" data-id="element-75">
                            Certification History
                          </h4>
                          <div className="space-y-4" data-id="element-76">
                            {cert.history?.map(event => <div key={event.id} className="flex items-start space-x-3" data-id="element-77">
                                <div className="flex-shrink-0" data-id="element-78">
                                  {getStatusIcon(event.status)}
                                </div>
                                <div className="flex-grow" data-id="element-79">
                                  <div className="flex items-center justify-between" data-id="element-80">
                                    <p className="text-sm font-medium text-gray-900" data-id="element-81">
                                      {event.type === 'submission' ? 'Document Submission' : 'System Notification'}
                                    </p>
                                    <span className="text-xs text-gray-500" data-id="element-82">
                                      {event.date}
                                    </span>
                                  </div>
                                  <p className="text-sm text-gray-600" data-id="element-83">
                                    {event.notes}
                                  </p>
                                  {event.document && <div className="mt-2 flex items-center space-x-2" data-id="element-84">
                                      <FileCheck className="w-4 h-4 text-gray-400" data-id="element-85" />
                                      <span className="text-sm text-gray-600" data-id="element-86">
                                        {event.document}
                                      </span>
                                    </div>}
                                  {event.reviewer && <p className="text-xs text-gray-500 mt-1" data-id="element-87">
                                      Reviewed by {event.reviewer}
                                    </p>}
                                </div>
                              </div>)}
                          </div>
                        </div>}
                    </div>)}
                </div>
              </div>
            </div>
          </div>
          {/* Sidebar */}
          <div className="space-y-6" data-id="element-88">
            {/* Communication History */}
            <div className="bg-white rounded-lg border" data-id="element-89">
              <div className="p-6 border-b border-gray-200" data-id="element-90">
                <div className="flex items-center justify-between" data-id="element-91">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-92">
                    Recent Communications
                  </h2>
                  <button className="text-purple-600 hover:text-purple-700" data-id="element-93">
                    <Send className="w-5 h-5" data-id="element-94" />
                  </button>
                </div>
              </div>
              <div className="p-6" data-id="element-95">
                <div className="space-y-4" data-id="element-96">
                  {supplier.communications.map(comm => <div key={comm.id} className="flex items-start space-x-3" data-id="element-97">
                      <div className={`p-2 rounded-full ${comm.type === 'email' ? 'bg-blue-100' : 'bg-green-100'}`} data-id="element-98">
                        {comm.type === 'email' ? <Mail className={`w-4 h-4 ${comm.type === 'email' ? 'text-blue-600' : 'text-green-600'}`} data-id="element-99" /> : <FileCheck className={`w-4 h-4 ${comm.type === 'email' ? 'text-blue-600' : 'text-green-600'}`} data-id="element-100" />}
                      </div>
                      <div data-id="element-101">
                        <p className="text-sm font-medium text-gray-900" data-id="element-102">
                          {comm.subject}
                        </p>
                        <p className="text-sm text-gray-600" data-id="element-103">
                          {comm.description}
                        </p>
                        <p className="text-xs text-gray-500 mt-1" data-id="element-104">
                          {comm.date}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
            {/* Quick Actions */}
            <div className="bg-white rounded-lg border p-6" data-id="element-105">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-106">
                Quick Actions
              </h3>
              <div className="space-y-3" data-id="element-107">
                <button className="w-full bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700" data-id="element-108">
                  Request Update
                </button>
                <button className="w-full border border-gray-200 text-gray-600 px-4 py-2 rounded-lg hover:bg-gray-50" data-id="element-109">
                  Download Reports
                </button>
                <button className="w-full border border-gray-200 text-gray-600 px-4 py-2 rounded-lg hover:bg-gray-50" data-id="element-110">
                  View Audit Log
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}